const $ = jQuery;

const HoverMenu = {
  init: function () {
    this.menuItem = $(".custom-cart-icon");
    this.subMenu = $(".cart-hover-content");
    this.closeIcon = $(".close-icon");
    this.setupEventListeners();
  },

  setupEventListeners: function () {
    this.menuItem.on("click", this.handleMenuClick.bind(this));

    this.closeIcon.on("click", this.handleCloseClick.bind(this));

    this.subMenu.on("click", function (event) {
      event.stopPropagation();
    });

    $(document).on("click", (event) => {
      if (
        !this.menuItem.is(event.target) &&
        !this.menuItem.has(event.target).length &&
        !this.subMenu.is(event.target) &&
        !this.subMenu.has(event.target).length
      ) {
        this.hideSubMenu();
      }
    });
  },

  handleMenuClick: function (event) {
    event.preventDefault();
    this.toggleSubMenu();
  },

  handleCloseClick: function (event) {
    event.stopPropagation();
    this.hideSubMenu();
  },

  toggleSubMenu: function () {
    if (this.subMenu.is(":visible")) {
      this.hideSubMenu();
    } else {
      this.showSubMenu();
    }
  },

  showSubMenu: function () {
    this.subMenu.stop(true, true).slideDown();
    $("body").addClass("cart-open"); 
  },

  hideSubMenu: function () {
    this.subMenu.stop(true, true).slideUp();
    $("body").removeClass("cart-open");
  },
};

export default HoverMenu;